export const environment = {
  production: false,
  apiUrl: 'https://api.forward-trial.zsservices.com',
  idmLoginUrl: 'https://javelin.zsservices.com/Argenx/IdentityManager-SSO/app/Web/login.aspx',
  idmMyAccount: 'https://javelin.zsservices.com/Argenx/IdentityManager-SSO/app/Web/MyAccount.aspx',
  idmLogoffUrl: 'https://javelin.zsservices.com/Argenx/IdentityManager-SSO/app/Web/logout.aspx?returnUrl=https%3a%2f%2fjavelin.zsservices.com%2fArgenx%2fIdentityManager-SSO%2fapp%2fWeb%2fMyAccount.aspx'
};